module.exports = __webpack_public_path__ + "bf6177c5a92d87d94f21202ba851c6b2.png";